import { createMutationHook } from '../client';
import { authenticated } from '../services/SignalsService';

export const useSignalsAuthenticated = createMutationHook(authenticated, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});
